import type { LinkHTMLAttributes } from 'react';

import { LanguageEnum } from '@Modules/app/constants';
import { getUrlByWebUri } from '@Modules/router/utils';
import type { RegionBasicType } from '@Modules/geo/types';

import { getListOfLinkDataForWebUriInfo } from './getListOfLinkDataForWebUriInfo';

export const getListOfLinkDataForPathname = (
  pathname: string,
  params: {
    region?: RegionBasicType | null;
    search?: string;
  } = {}
): Array<LinkHTMLAttributes<HTMLLinkElement>> => {
  const { region, search } = params;

  const result: Record<string, string> = {};

  Object.values(LanguageEnum).forEach((language) => {
    result[language] = getUrlByWebUri({
      pathname,
      // NOTE: take the correct region name for the language
      region: region ? region.webUriInfo[language].split('/')[1] : undefined,
      language,
      search,
    });
  });

  return getListOfLinkDataForWebUriInfo(result);
};
